import BaseService from '../BaseService.js'

export default class SftpService extends BaseService {

  constructor() {
    super('sftp-files')
  }

  async getfiles() {
    await this.getImportBackendListUrl().then(url => this.serviceurl = url)
    return this.checkError(
      fetch(`${this.serviceurl}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }

  async download(kategorie, fileName) {
    await this.getImportBackendListUrl().then(url => this.serviceurl = url)
    return fetch(`${this.serviceurl}/download/${kategorie}/${fileName}`, {
      method: 'GET',
      cache: 'reload',
      headers: this.getJsonHeader()
    })
      .then(response => response.blob())
      .then(blob => download(fileName, blob))
  }

}
